<template>
  <div class="table-light table-responsive">
    <table
      role="table"
      aria-busy="false"
      aria-colcount="5"
      class="table b-table table-hover table-striped table-bordered"
      id="__BVID__310"
    >
      <thead role="rowgroup" class="">
        <tr role="row" class="">
          <th
            v-for="(column, index) in data.columns"
            :key="index"
            role="columnheader"
            scope="col"
            :aria-colindex="index"
            class=""
          >
            <div class="table__title">{{ column }}</div>
          </th>
        </tr>
      </thead>
      <tbody role="rowgroup">
        <RegistrationCompensationTableRowComponent
          v-for="(row, index) in data.data"
          :row="row"
          :rowIndex="index"
          :dataLength="Object.keys(data.data).length"
          :key="index"
          :isEditable="isEditable"
          @editCost="editCost"
        />
      </tbody>
      <caption class="caption" v-if="data.hasConvention">
        <span class="textStyle fw-bold me-2">{{ $t("registration.quote.final_cost") }}</span>
        <span>{{ $t("registration.quote.initial_cost") }}</span>
      </caption>
    </table>
  </div>
</template>

<script>
import RegistrationCompensationTableRowComponent from "@/components/registration/quote/table/RegistrationCompensationTableRowComponent.vue";

export default {
  name: "RegistrationCompensationTableComponent",
  components: { RegistrationCompensationTableRowComponent },
  props: {
    data: {
      type: Object,
      required: true,
    },
    isEditable: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  emits: ["editCost"],
  methods: {
    editCost(cell) {
      this.$emit("editCost", cell);
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  margin-bottom: 0;

  &__title {
    padding-left: 10px;
    padding-right: 10px;
  }
}

.caption {
  text-align: end;
  font-size: 12px;
}

.table > :not(caption) > * > * {
  @include dark-theme {
    background-color: inherit !important;
  }
}
</style>
